import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//import TiChartPie from 'react-icons/lib/ti/chart-pie'
import FaBolt from 'react-icons/lib/fa/bolt';
import FaHddO from 'react-icons/lib/fa/hdd-o';
import FaSliders from 'react-icons/lib/fa/sliders';
import FaCloudUpload from 'react-icons/lib/fa/cloud-upload';
import FaDollar from 'react-icons/lib/fa/dollar';
import FaUser from 'react-icons/lib/fa/user';
import FaCogs from 'react-icons/lib/fa/cogs';
import FaServer from 'react-icons/lib/fa/server';
import FaHistory from 'react-icons/lib/fa/history';
import FaHome from 'react-icons/lib/fa/home';
import FaDesktop from 'react-icons/lib/fa/desktop';
import FaCodeFork from 'react-icons/lib/fa/code-fork';
import FaInfo from 'react-icons/lib/fa/info';
import FaCheckSquareO from 'react-icons/lib/fa/check-square-o';
import FaThLarge from 'react-icons/lib/fa/th-large';

import { HashLink } from 'react-router-hash-link';

import { Link } from 'react-router-dom';

const styles = {
  siteTitle: {
    display: 'flex',
    justifyContent: 'center',
    //height: 60,
    marginTop: 10,
  },
  sideTitleImage: {
    margin: 0,
    padding: 0,
    width: 200,
    //marginLeft: 20
  },
  sidebar: {
    width: 256,
    fontFamily: 'Rubik',
    height: '100%',
  },
  sidebarLink: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 16px',
    color: '#757575',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  linkTitle: {
    marginLeft: 10,
  },
  divider: {
    margin: '8px 0',
    height: 1,
    backgroundColor: '#757575',
  },
  content: {
    // padding: '16px',
    height: 'calc(100% - 60px)',
    backgroundColor: '#2F323E',
  },
};

const linkConfig = [
  {
    path: '/doc/home',
    title: 'Product Overview',
    icon: <FaHome />,
  },
  {
    path: '/doc/integrations',
    title: 'Integration Levels',
    icon: <FaCodeFork />,
  },
  {
    path: '/doc/capabilities',
    title: 'Features',
    icon: <FaHome />,
  },
  {
    path: '/doc/api',
    title: 'API Access',
    icon: <FaDesktop />,
  },
  {
    path: '/doc/audience',
    title: 'Create Audiences',
    icon: <FaSliders />,
  },
  {
    path: '/doc/file_upload',
    title: 'Import Segments',
    icon: <FaCloudUpload />,
  },
  {
    path: '/doc/tracking_upload_status',
    title: 'Tracking Imports',
    icon: <FaHistory />,
  },
  {
    path: '/doc/license',
    title: 'License an Audience',
    icon: <FaCogs />,
  },
  {
    path: '/doc/limits',
    title: 'Account Limits',
    icon: <FaThLarge />,
  },
  {
    path: '/doc/revenue',
    title: 'Revenues Report',
    icon: <FaDollar />,
  },
  {
    path: '/doc/sla',
    title: 'SLA',
    icon: <FaCheckSquareO />,
  },
  {
    path: '/doc/faq',
    title: 'FAQ',
    icon: <FaInfo />,
  },
];

class DocDrawer extends Component {
  state = {
    // update this date string after each update
    lastUpdated: '11/06/2019',
  };

  render() {
    const style = this.props.style
      ? { ...styles.sidebar, ...this.props.style }
      : styles.sidebar;

    const { pathname } = this.props.location;

    return (
      <div title='Menu' style={style}>
        <div className='' style={styles.siteTitle}>
          <center>
            <img
              src='/img/audiencerate-logo.png'
              style={styles.sideTitleImage}
              alt='audience rate'
            />
          </center>
        </div>
        <div className=''>
          <center>
            <font
              style={{ fontSize: '11px', position: 'relative', top: '-5px' }}
            >
              Last Updated: {this.state.lastUpdated}
            </font>
          </center>
        </div>
        <div style={styles.content}>
          {linkConfig.map((link) => {
            const linkStyle =
              pathname === link.path
                ? { backgroundColor: '#2768EF', color: 'white' }
                : {};
            return (
              <Link
                key={link.path}
                to={link.path}
                style={{ ...styles.sidebarLink, ...linkStyle }}
              >
                {link.icon}
                <span style={styles.linkTitle}>{link.title}</span>
              </Link>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DocDrawer)
);
